import React from "react";
import PropTypes from "prop-types";
import StyledFilterPriceRadioFlower from "./FilterPriceRadioFlower.styled";
import { filterRangePT } from "../../config/prop-types";

const FilterPriceRadioFlower = React.memo(props => {
  const { range, checkFilter, checked, disabled } = props;
  return (
    <StyledFilterPriceRadioFlower className={`filter-product-price__radio ${checked && "is-checked"}`}>
      <input disabled={disabled} checked={checked} onChange={() => checkFilter(range.id.toString(), range.value[0], range.value[1])} type="radio" />
      <span className="filter-product-price__radio__custom"></span>
      <span className="t-body-small filter-product-price__radio__copy">{range.name}</span>
    </StyledFilterPriceRadioFlower>
  );
});

FilterPriceRadioFlower.propTypes = {
  range: filterRangePT.isRequired,
  checkFilter: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default FilterPriceRadioFlower;